import React, { useState, useRef } from "react";
import { Container, Form, Button, Row, Col, Alert } from "react-bootstrap";
import axiosInstance from "../../api/axios";

export default function ApprovalRequest() {
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    content: "",
    attachment: null,
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileInputRef = useRef();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0]; // 선택된 파일
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (file) {
      if (file.size > maxSize) {
        alert("파일 크기가 5MB를 초과할 수 없습니다."); // 경고 메시지 표시
        e.target.value = ""; // 선택 초기화
        setFormData({
          ...formData,
          attachment: null, // 파일 초기화
        });
      } else {
        setFormData({
          ...formData,
          attachment: file, // 유효한 파일 저장
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation check
    if (!formData.title || !formData.category || !formData.content) {
      setError("필수 항목을 모두 입력해주세요.");
      return;
    }

    setError("");
    setSuccess(false);
    setLoading(true);

    try {
      let attachmentPath = null;

      // 첨부파일이 있을 경우 Presigned URL 요청 및 S3 업로드
      if (formData.attachment) {
        // const sanitizedFileName = encodeURIComponent(formData.attachment.name);
        const base64FileName = btoa(
          encodeURIComponent(formData.attachment.name)
        );

        const presignedUrlResponse = await axiosInstance.get(
          "/api/approval-request/presigned-url",
          {
            params: { fileName: base64FileName },
          }
        );

        const presignedUrl = presignedUrlResponse.data.data;

        // S3에 파일 업로드
        await axiosInstance.put(presignedUrl, formData.attachment, {
          headers: {
            "Content-Type":
              formData.attachment.type || "application/octet-stream",
          },
          withCredentials: false,
        });

        // 파일 경로 저장
        attachmentPath = presignedUrl.split("?")[0];
      }

      // 결재 요청 정보 저장
      const requestPayload = {
        title: formData.title,
        category: formData.category,
        content: formData.content,
        attachmentPath, // 첨부파일이 없으면 null로 전달
      };

      await axiosInstance.post("/api/approval-request", requestPayload);

      setSuccess(true);
      setFormData({
        title: "",
        category: "",
        content: "",
        attachment: null,
      });

      // 파일 입력 필드 초기화
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    } catch (err) {
      console.error("결재 요청 처리 중 오류 발생:", err);
      setError("결재 요청 중 문제가 발생했습니다. 다시 시도해주세요.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="my-5">
      <h3 className="mb-4">결재 요청</h3>

      {error && <Alert variant="danger">{error}</Alert>}
      {success && (
        <Alert variant="success">결재 요청이 성공적으로 제출되었습니다.</Alert>
      )}

      <Form onSubmit={handleSubmit}>
        {/* 제목 */}
        <Form.Group controlId="title" className="mb-3">
          <Form.Label>
            제목<span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            name="title"
            value={formData.title}
            onChange={handleChange}
            placeholder="결재 요청 제목을 입력하세요"
          />
        </Form.Group>

        {/* 구분 */}
        <Form.Group controlId="category" className="mb-3">
          <Form.Label>
            구분<span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </Form.Label>
          <Form.Select
            name="category"
            value={formData.category}
            onChange={handleChange}
          >
            <option value="">구분을 선택하세요</option>
            <option value="EXPENDITURE">지출</option>
            <option value="EMPLOYMENT">재직증명서</option>
            <option value="OTHER">기타</option>
          </Form.Select>
        </Form.Group>

        {/* 내용 */}
        <Form.Group controlId="content" className="mb-3">
          <Form.Label>
            내용<span style={{ color: "red", marginLeft: "5px" }}>*</span>
          </Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            name="content"
            value={formData.content}
            onChange={handleChange}
            placeholder="결재 요청 내용을 입력하세요"
          />
        </Form.Group>

        {/* 첨부파일 */}
        <Form.Group controlId="attachment" className="mb-3">
          <Form.Label>첨부파일</Form.Label>
          <Form.Control
            type="file"
            ref={fileInputRef}
            onChange={handleFileChange}
          />
        </Form.Group>

        <div className="d-flex justify-content-end">
          <Button type="submit" variant="primary" disabled={loading}>
            {loading ? "제출 중..." : "제출"}
          </Button>
        </div>
      </Form>
    </Container>
  );
}
